import { render, staticRenderFns } from "./linked-field-icon.vue?vue&type=template&id=4ef305f8&"
import script from "./linked-field-icon.vue?vue&type=script&lang=js&"
export * from "./linked-field-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ef305f8')) {
      api.createRecord('4ef305f8', component.options)
    } else {
      api.reload('4ef305f8', component.options)
    }
    module.hot.accept("./linked-field-icon.vue?vue&type=template&id=4ef305f8&", function () {
      api.rerender('4ef305f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/surveys/linked-field-icon.vue"
export default component.exports